<template>
  <div class="landing" @click="goToHome">
    <AyeAnimation />
  </div>
</template>

<script>
import AyeAnimation from "@/components/AyeAnimation.vue";

export default {
  name: "LandingPage",
  components: {
    AyeAnimation,
  },
  methods: {
    goToHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<style>
body {
  overflow: hidden;
}
.landing {
  box-sizing: border-box;
  margin: 0;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  height: 100vh;
  position: relative;
  overflow: hidden;
}
</style>
